import React from 'react';
import { PresetView } from 'pages/Shipments/Containers/types';
import { Link } from 'react-router-dom';
import { Card } from 'components/tailwind-ui/Card';
import { CountCard } from '../CountCard';
import { CardTitle } from './CardTitle';
import { useCountFromAPI } from '../../hooks';

interface FooterProps {
  text: string;
  presetView: PresetView;
}

interface Props {
  textColor: string;
  backgroundColor: string;
  icon: React.ReactNode;
  presetView: PresetView;
  text: string;
  footerLeft?: FooterProps;
  footerRight?: FooterProps;
  iconClasses: string;
}

export const StatusCard = (props: Props) => {
  const {
    textColor,
    backgroundColor,
    icon,
    presetView,
    text,
    footerLeft,
    footerRight,
    iconClasses,
  } = props;

  const { inner, preset, handleClick } = useCountFromAPI(presetView);

  return (
    <Card className={`${!footerLeft && !footerRight && 'flex'}`}>
      <Link
        to={preset.to}
        onClick={handleClick}
        className="group p-4 hover:bg-gray-100 hover:border-blue-900 transition-colors flex grow"
      >
        <div className="flex items-start ">
          <CardTitle
            textColor={textColor}
            backgroundColor={backgroundColor}
            icon={icon}
            count={inner}
            text={text}
            iconClasses={iconClasses}
          />
        </div>
      </Link>
      {footerLeft && footerRight && (
        <div className="grid grid-cols-2 divide-gray-300 divide-x">
          <CountCard title={footerLeft.text} presetView={footerLeft.presetView} />
          <CountCard title={footerRight.text} presetView={footerRight.presetView} />
        </div>
      )}
    </Card>
  );
};
